import {Root} from "./store-root";
import {action, computed, observable, runInAction} from "mobx";
import {API} from "aws-amplify";
import {Ticket, TicketStatus} from '../models/Ticket';

export class SupportTicketsStore {
    parent: Root;
    @observable OutstandingTicket = new Map();
    @observable Tickets = new Map();
    @observable MyTickets: Ticket[] = [];

    constructor(root: Root) {
        this.parent = root
    }

    @action LoadOutstandingTickets = async () => {
        const fromBackend: Ticket[] = await API.get('backend', '/tickets/open', {});
        console.log('Tickets from backend: ', fromBackend);

        if (fromBackend) {
            this.OutstandingTicket.clear();
            fromBackend.forEach((item: Ticket) => {
                this.OutstandingTicket.set(item.Id, item);
            })
        }
    }

    @action LoadMyTickets = async (userId: string) => {
        if (userId) {
            const foundLocally: Ticket[] = Array.from(this.Tickets.values()).filter(((item: Ticket) => item.CreatedBySub === userId))
            if (foundLocally && foundLocally.length > 0)
                runInAction(()=>{
                    this.MyTickets=[];
                    this.MyTickets = foundLocally;
                })
            else {
                const fromBackend = await API.get('backend', `/tickets/agent/${userId}`, {})
                if(fromBackend)
                {
                    this.MyTickets=[];
                    this.MyTickets = fromBackend;
                }
            }
        }
    }

    @action LoadAllTickets = async () => {
        this.Tickets.clear();
        const fromBackend: Ticket[] = await API.get('backend', '/tickets', {});
        console.log('Tickets from backend: ', fromBackend);
        this.Tickets.clear();
        if (fromBackend) {
            fromBackend.forEach((item: Ticket) => {
                this.Tickets.set(item.Id, item);
            })
        }
    }

    @computed get AllTicketsFilteredToOutstanding() {
        const transformed: Ticket[] = Array.from(this.Tickets.values());
        const filtered = transformed.filter((item: Ticket) => item.Status =="0");
        return filtered;
    }

    @action LoadTicket = async (id: string) => {
        if (id) {
            const foundLocally: Ticket = this.Tickets.get(id);
            if (foundLocally)
                return foundLocally;
            else {
                const fromBackend: Ticket = await API.get('backend', `/tickets/edit/${id}`, {})
                if (fromBackend) {
                    this.Tickets.set(fromBackend.Id, fromBackend);
                    return fromBackend;
                }
            }
        }
    }

    @action LoadTicketsForOrder = async (reference: string) => {
        let found: Ticket[] = [];
        if (reference) {
            const localTickets = Array.from(this.Tickets.values());
            if (localTickets && localTickets.length > 0) {
                found = localTickets.filter((item: Ticket) => item.Reference === reference);
                if (found)
                    return found;
            } else {
                try {
                    found = await API.get('backend', `/tickets/${reference}`, {})
                    return found;
                } catch (e) {
                    console.log(`Error during retrieving order tickets `, e.response.data);
                }
            }
        }
        return found;
    }


    @action LoadOpenTicketsForOrder = async (reference: string) => {
        let found: Ticket[] = [];
        if (reference) {
            const localTickets = Array.from(this.Tickets.values());
            if (localTickets && localTickets.length > 0) {
                found = localTickets.filter((item: Ticket) => item.Reference === reference);
                if (found)
                    return found;
            } else {
                try {
                    found = await API.get('backend', `/tickets/${reference}/open`, {})
                    return found;
                } catch (e) {
                    console.log(`Error during retrieving order tickets `, e.response.data);
                }
            }
        }
        return found;
    }


    @action OpenTicket = async (ticket: Ticket) => {
        ticket.Status = '0';
        await API.post('backend', `/tickets`, {'body': {...ticket}})
        await this.LoadAllTickets();
        await this.LoadMyTickets(this.parent.Users.Sub);
    }

    @action CloseTicket = async (ticket: Ticket) => {
        ticket.Status = '1'
        await API.put('backend', `/tickets`, {'body': {...ticket}})
        await this.LoadAllTickets();
        await this.LoadMyTickets(this.parent.Users.Sub);
    }


    @action SaveTicket = async (ticket: Ticket) => {
        await API.put('backend', `/tickets`, {'body': {...ticket}})
        await this.LoadAllTickets();
        await this.LoadMyTickets(this.parent.Users.Sub);
    }

    @action CancelTicket = async (ticket: Ticket) => {
        ticket.Status = '2'
        await API.put('backend', `/tickets`, {'body': {...ticket}})
        await this.LoadAllTickets();
        await this.LoadMyTickets(this.parent.Users.Sub);
    }

}